import React, { useState } from "react";
import PropTypes from "prop-types";
import { navigate } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Col, Collapse, Row } from "react-bootstrap";

import Card from "./Card";
import RequestDemoForm from "./RequestDemoForm";
import FacilitySupportForm from "./FacilitySupportForm";

import { getFormLead } from "../utils/utils";

const TogglerCards = ({ cards }) => {
    const [open, setOpen] = useState("");

    if (!cards?.length) {
        return null;
    }

    const onClick = (e, type, link) => {
        e.preventDefault();
        if (!link) return;

        if (type === "Toggler") {
            setOpen(link);
            return;
        }

        navigate(link);
    };

    return [
        <Row className="h-100">
            {cards.map(card => (
                <Col key={card.link} className="my-2">
                    <Card
                        {...card}
                        onClick={e => onClick(e, card.type, card.link)}
                    />
                </Col>
            ))}
        </Row>,
        <Collapse in={open === "request-demo-form"} className="my-5">
            <Row>
                <Col xs={12} md={7}>
                    <RequestDemoForm
                        submitId="contact-form-sales-inquiries"
                        lead={getFormLead(
                            "Seeing Is Believing",
                            "Submit your information, and a sales representative will contact you shortly."
                        )}
                        submitButtonLabel="Submit"
                    />
                </Col>
                <Col md={5} className="side-form-image d-none d-md-block">
                    <StaticImage
                        src="../images/content/providers-form-image.png"
                        alt="Request demo image"
                        className="side-image"
                    />
                </Col>
            </Row>
        </Collapse>,
        <Collapse in={open === "facility-support-form"} className="my-5">
            <Row>
                <Col xs={12} md={7}>
                    <FacilitySupportForm
                        submitId="contact-form-facility-support"
                        lead={getFormLead(
                            "Support Request",
                            "Submit your information and a detailed message to have a customer care representative contact you."
                        )}
                    />
                </Col>
                <Col md={5} className="side-form-image d-none d-md-block">
                    <StaticImage
                        src="../images/content/facility-support-form.png"
                        alt="Facility support image"
                        className="side-image"
                    />
                </Col>
            </Row>
        </Collapse>,
    ];
};

TogglerCards.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            customId: PropTypes.string,
            copy: PropTypes.shape({ raw: PropTypes.string }).isRequired,
            link: PropTypes.string,
            linkText: PropTypes.string,
            type: PropTypes.string,
        })
    ),
};

export default TogglerCards;
